var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { Tag } from '@citrus/tag';
import { inputBaseActionArea as inputBaseActionAreaLegacy } from '../../../styles/legacy';
import { inputBaseActionArea as inputBaseActionAreaCitrus2022 } from '../../../styles/citron';
import { sortBy } from 'lodash';
export var selectOrDeselectItem = function (item, selected, sortKey) {
    if (selected.findIndex(function (x) { return x.value === item.value; }) >= 0) {
        return selected.filter(function (x) { return x.value !== item.value; });
    }
    return sortBy(__spreadArray(__spreadArray([], selected, true), [item], false), sortKey);
};
export var getLines = function (el) {
    var spans = el;
    var lastOffset = 0;
    var line = [];
    var l = 0;
    var lines = [];
    // for each tag in the list
    for (var i = 0; i < spans.length; i++) {
        // get the offset from the top of the browser for the tag
        var offset = spans[i].offsetTop + spans[i].clientHeight;
        if (offset === lastOffset) {
            // if that offset is the same as the previous offset then add this tag to the line
            line.push(spans[i]);
        }
        else {
            // if its not then make a new line
            // eslint-disable-next-line no-plusplus
            if (line.length > 0)
                lines[l++] = line;
            // and add the span
            line = [spans[i]];
        }
        lastOffset = offset;
    }
    // push the last line at the end
    lines.push(line);
    return lines;
};
export var useKeyPress = function (event, keys) {
    var code = event.code, key = event.key;
    return event.type === 'keydown' && (keys.includes(code) || keys.includes(key));
};
// Needs .tsx
export var checkHowManyFit = function (val) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var childArray = val.childArray, moreText = val.moreText, parent = val.parent, grandParent = val.grandParent, isCitron = val.isCitron;
    // array of what fits
    var returnFittingArray = [];
    /**
     * this next block is essentially 'simulating' the action area of the input.  the container is hidden, and will render the pills for measurement.  it will be deleted before the array gets returned
     */
    var container = document.createElement('span');
    container.setAttribute('style', 'visibility: hidden; z-index: -1; display: inline-flex;');
    var grandparentContainer = document.createElement('div');
    var inputBaseActionArea = isCitron ? inputBaseActionAreaCitrus2022 : inputBaseActionAreaLegacy;
    // this style for the grandparentContainer should match inputBaseActionArea in inputBase_styles.ts, we take in that style, and add it to the created grandparent here.
    if (inputBaseActionArea && Object.keys(inputBaseActionArea).length > 0) {
        var actionAreaStyles_1 = __assign(__assign({}, inputBaseActionArea), { display: 'block', visibility: 'hidden', 'z-index': '-1', position: 'absolute', overflow: 'hidden' });
        Object.keys(actionAreaStyles_1).map(function (key) { return (grandparentContainer.style[key] = actionAreaStyles_1[key]); });
    }
    var parentOfGrandParent = grandParent === null || grandParent === void 0 ? void 0 : grandParent.parentElement;
    var parentContainer = parent.cloneNode();
    parentContainer.appendChild(container);
    grandparentContainer.appendChild(parentContainer);
    parentOfGrandParent === null || parentOfGrandParent === void 0 ? void 0 : parentOfGrandParent.appendChild(grandparentContainer);
    var checkIfMoreFits = function (index) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (index < 0)
            return;
        var moreTag = React.createElement(Tag, { type: 'pill', value: "+".concat(childArray.length - index, " ").concat(moreText) });
        var moreString = ReactDOMServer.renderToString(moreTag);
        container.innerHTML += moreString;
        var moreItem = container.children[container.children.length - 1];
        // if the more tag fits return
        if (Math.floor((_d = (_c = (_b = (_a = moreItem === null || moreItem === void 0 ? void 0 : moreItem.getClientRects) === null || _a === void 0 ? void 0 : _a.call(moreItem)) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.right) !== null && _d !== void 0 ? _d : 0) <=
            Math.floor((_h = (_g = (_f = (_e = grandparentContainer === null || grandparentContainer === void 0 ? void 0 : grandparentContainer.getClientRects) === null || _e === void 0 ? void 0 : _e.call(grandparentContainer)) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.right) !== null && _h !== void 0 ? _h : 0)) {
            return;
        }
        // remove the more tag and the previous tag from the container AND the returnFittingArray and check again at the previous index
        for (var domIndex = 0; domIndex < 2; domIndex++) {
            if (container.children.length === 0)
                break;
            container.removeChild(container.children[container.children.length - 1]);
        }
        returnFittingArray.pop();
        checkIfMoreFits(index - 1);
    };
    for (var i = 0; i < childArray.length; i++) {
        if (childArray[i].header) {
            continue;
        }
        var x = childArray[i];
        var newTag = (React.createElement(Tag, { key: i, onClickClose: x && !x.header ? function () { return undefined; } : undefined, onMouseDown: function (e) {
                e.preventDefault();
                e.stopPropagation();
            }, type: 'pill', value: x.label }));
        var newTagHtml = ReactDOMServer.renderToString(newTag);
        container.innerHTML += newTagHtml;
        var item = container.children[container.children.length - 1];
        // if the options fits!
        if (Math.floor((_d = (_c = (_b = (_a = item === null || item === void 0 ? void 0 : item.getClientRects) === null || _a === void 0 ? void 0 : _a.call(item)) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.right) !== null && _d !== void 0 ? _d : 0) <=
            Math.floor((_h = (_g = (_f = (_e = grandparentContainer === null || grandparentContainer === void 0 ? void 0 : grandparentContainer.getClientRects) === null || _e === void 0 ? void 0 : _e.call(grandparentContainer)) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.right) !== null && _h !== void 0 ? _h : 0)) {
            returnFittingArray.push(x);
        }
        else {
            // remove the first item that doesnt fit, then recursively check if the more tag fits
            if (container.children.length > 0) {
                container.removeChild(container.children[container.children.length - 1]);
            }
            checkIfMoreFits(i);
            break;
        }
    }
    /**
     * cleanup
     */
    // FIXME: unmountComponentAtNode is deprecated, refactor to use React 18 root.unmount()
    // eslint-disable-next-line react/no-deprecated
    ReactDOM.unmountComponentAtNode(grandparentContainer);
    parentOfGrandParent === null || parentOfGrandParent === void 0 ? void 0 : parentOfGrandParent.removeChild(grandparentContainer);
    return returnFittingArray;
};
export var getWindowSize = function () {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
};
